import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconStartCalendar: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        d="M15.39 5.21L16.7999 8.03C16.9899 8.42 17.4999 8.79 17.9299 8.87L20.48 9.29C22.11 9.56 22.49 10.74 21.32 11.92L19.3299 13.91C18.9999 14.24 18.81 14.89 18.92 15.36L19.4899 17.82C19.9399 19.76 18.9 20.52 17.19 19.5L14.7999 18.08C14.3699 17.82 13.65 17.82 13.22 18.08L10.8299 19.5C9.11994 20.51 8.07995 19.76 8.52995 17.82L9.09996 15.36C9.20996 14.9 9.01995 14.25 8.68995 13.91L6.69996 11.92C5.52996 10.75 5.90996 9.57 7.53996 9.29L10.0899 8.87C10.5199 8.8 11.03 8.42 11.22 8.03L12.63 5.21C13.38 3.68 14.62 3.68 15.39 5.21Z"
        fill="#F54E95"
      />
      <path
        opacity="0.4"
        d="M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z"
        fill="#F54E95"
      />
      <path
        opacity="0.4"
        d="M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z"
        fill="#F54E95"
      />
      <path
        opacity="0.4"
        d="M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z"
        fill="#F54E95"
      />
    </Icon>
  );
};

export default IconStartCalendar;
